export default {
  contact: {
    description: 'Return a list of my contact information.',
    list: [
      {
        type: 'info',
        label: 'Email:',
        content: '`kunpengl0111@gmail.com`'
      },
      {
        type: 'info',
        label: 'Github:',
        content: '`https://github.com/kpl0111`'
      },
      {
        type: 'info',
        label: 'Twitter:',
        content: '`https://twitter.com/Nefelib31847846`'
      }
    ]
  },
  skill: {
    description: 'Return a list of my skills and my rating of them.',
    list: [
      // { type: 'success', label: 'A', content: '· JavaScript 99/100' },
      // { type: 'success', label: 'A', content: '· Go 90/100' },
      // { type: 'success', label: 'A', content: '· Kotlin 80/100' },
      { type: 'success', label: 'A', content: '· C++ 80/100' },

      // { type: 'warning', label: 'B', content: '· TypeScript 70/100' },
      { type: 'warning', label: 'B', content: '· C 70/100' },
      // { type: 'warning', label: 'B', content: '· Shell 70/100' },

      
      { type: 'warning', label: 'C', content: '· Python 60/100' },
      { type: 'error', label: 'C', content: '· Java 50/100' },
      // { type: 'error', label: 'C', content: '· C# 60/100' },
      // { type: 'error', label: 'C', content: '· Rust 60/100' },
      // { type: 'error', label: 'C', content: '· Scala 60/100' },
      // { type: 'error', label: 'C', content: '· Lua 60/100' },
      // { type: 'error', label: 'C', content: '· Haskell 60/100' },
      // { type: 'error', label: 'C', content: '· Ruby 60/100' },

      // { type: 'black', label: 'D', content: '· CSS -999/100' }
    ]
  },
  movie: {
    description: 'Return a list of movies that I have watched.',
    list: [
      ' 《 加勒比海盗系列 》',
      ' 《 泰坦尼克号 》'
    ]
  },
  book: {
    description: 'Return a list of books that I have read.',
    list: [
      ' 《 天才在左 疯子在右 》--- 高铭 ',
      ' 《 动物农场 》--- Geogle Orwell ',
      ' 《 魔鬼与普里姆小姐 》--- Paulo Coelho ',
      ' 《 牧羊少年奇幻之旅 》---  Paulo Coelho ',
      ' 《 安德的游戏 》--- Orson Scott Card ',
      ' 《 偷影子的人 》--- Marc Levy ',
      ' 《 小王子 》--- Antoine de Saint-Exupery ',
      ' 《 摆渡人 》--- Claire McFall ',
      ' 《 摆渡人2重返荒原 》--- Claire McFall ',
      ' 《 太阳帆船 》--- 星河 选评 ',
      ' 《 追风筝的人 》--- Khaled Hosseini ',
      ' 《 三体系列 》--- 刘慈欣 '
    ]
  }
}
